import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { cellOperation } from './tables';
import Icon from '../components/UI/Icon';

let icon = <FontAwesomeIcon icon={faExclamationCircle} style={{color: 'var(--orsan-blue)'}} />;
let msg = 'Sin comentarios';
export const setIconAndMsg = (inputRow) => {
  let rowData = inputRow;
  if (typeof rowData === 'string') {
    try {
      rowData = JSON.parse(rowData);
    } catch (e) {
      rowData = {};
    }
  }
  icon = <FontAwesomeIcon icon={faExclamationCircle} style={{ color: 'var(--orsan-blue)', fontSize: '15px' }} />;
  msg = rowData.comentarios || msg;
};

export const getIconInfo = (row, tableCell=true) => {
  setIconAndMsg(row);

  const iconElement = (
    <Icon id={`check-${row.index}`} tooltipText={msg}>
      {icon}
    </Icon>
  );
  
  return tableCell ? cellOperation(iconElement) : iconElement;
};
